import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { TrafficBySourceTileComponent } from './traffic-by-source-tile.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule],
  declarations: [TrafficBySourceTileComponent],
  exports: [TrafficBySourceTileComponent]
})
export class TrafficBySourceTileModule {}
